import { WarningBadge } from './WarningBadge';

export const NotMappedWarning: React.FC = () => (
  <WarningBadge text="Not Mapped" />
);
